import { FilesTabContent } from 'app/pages/recordv1/virtualBackgrounds/FilesTabContent';
import { NewModal } from 'lib/components';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  handleModalClose: () => void;
  onSelect: (selectedImageUrl: string) => void;
};

export const ModalFilesChooseImage = ({
  handleModalClose,
  onSelect,
}: Props) => {
  const { t } = useTranslation();
  return (
    <NewModal headerText={t('Select your image')} closeModal={handleModalClose}>
      <FilesTabContent
        onSelect={onSelect}
        handleModalClose={handleModalClose}
        selectedVirtualBackgroundUrl=''
      />
    </NewModal>
  );
};
